import { render, staticRenderFns } from "./recognize_list.vue?vue&type=template&id=467c3013&scoped=true"
import script from "./recognize_list.vue?vue&type=script&lang=js"
export * from "./recognize_list.vue?vue&type=script&lang=js"
import style0 from "./recognize_list.vue?vue&type=style&index=0&id=467c3013&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467c3013",
  null
  
)

export default component.exports